import React, { useState,useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { MyApolloClient } from '../components';
import { useStateContext } from '../contexts/ContextProvider';
import ShopIcon from '@mui/icons-material/Shop'; // Import the shop icon
import RefreshIcon from '@mui/icons-material/Refresh';


import Coupon from '../components/Coupon';
import { GET_USER_COUPONS } from '../graphql/queries'; // Assuming the query is saved here


import Loading from '../components/Loading'; // Make sure you have a Loading component

import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import IconButton from '@mui/material/IconButton';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';



const Dashboard = () => {

  const userId = localStorage.getItem('userId');
  MyApolloClient.link.options.headers.Authorization = `Bearer ${localStorage.getItem('jwt')}`;

  const fetch_number = 250; // The number of coupons you want to fetch per page
  const itemsPerPage = 10; // Number of items you want to display per page
  const [timerDone, setTimerDone] = useState(false);

  const { searchTerm,currentPage, setCurrentPage,filteredData, setFilteredData } = useStateContext(); // Use the search term from the context

  const buttonStyles = {
    color:'#434343',
    backgroundColor:' #e6e6e6',
    '&.Mui-disabled': {
      backgroundColor: 'transparent' // Background color when disabled
    }
  };

  // Set up the variables for the GraphQL query
  let variables = {
    offset: 0, 
    limit: fetch_number, 
  };


  // Fetch coupons for the current user with useQuery
  const { loading, error, data, refetch } = useQuery(GET_USER_COUPONS, {
    variables: variables, // Use the variables object with userId, limit, and offset
    skip: !userId, // Skip the query if there is no user ID
    fetchPolicy: 'network-only', // Use this policy to get fresh data
  });

  

  useEffect(() => {
    setTimeout(() => {
      setTimerDone(true);
    }, 500); //for loading expirience

    const userCoupons = data?.myCupons ?? [];

    if (userCoupons.length > 0) {
      const filtered = userCoupons.filter(coupon =>
        coupon.name.toLowerCase().startsWith(searchTerm.toLowerCase())
      );

      console.log("Filtered Coupons: ", filtered);
      setFilteredData(filtered);
    } else if (data) {
      setFilteredData([]);
    }
  }, [data, searchTerm, setFilteredData]);



  const currentPageData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
 
  const totalPageCount = Math.ceil(filteredData.length / itemsPerPage);
 

  const handlePreviousPage = () => {
    setCurrentPage(prevPage => Math.max(1, prevPage - 1));
  };

  const handleNextPage = () => {
    setCurrentPage(prevPage => Math.min(prevPage + 1, totalPageCount));
  };

  if (loading || (currentPageData.length === 0 && !timerDone)) return <Loading />; // Show loading state while data is fetching
  if (error) return <p>Error</p>; // Error handling
  return (
    <div className='my-4'>
     {/* Container with Grid */}
    <div className="grid grid-cols-3 items-center">
      <div></div> {/* Empty div for left alignment */}

      {/* Centered Pagination Controls */}
      <div className="flex justify-center items-center">
        <IconButton
            onClick={handlePreviousPage}
            variant="contained"
            disabled={currentPage === 1} // Disable if on the first page
            sx={buttonStyles}
        >
          <KeyboardArrowLeftIcon/>
        </IconButton>
        <span className=' mx-2 font-bold' >{currentPage}</span>
        <IconButton
          onClick={handleNextPage}
          disabled={currentPage >= totalPageCount || currentPageData.length < itemsPerPage} // Disable if on the last page or if current page data is less than items per page
          sx={buttonStyles}
        >
          <KeyboardArrowRightIcon/>
        </IconButton>
      </div>

      {/* Right-aligned Coupon Count */}
      <div className='flex justify-end items-center pr-4'>
        <span className='mx-2 font-semibold	'>{filteredData.length}</span>
        <LocalOfferIcon /> {/* Coupon Icon */}
      </div>
    </div>

      {currentPageData.length > 0 ? (
        currentPageData.map((coupon) => (
          

          <Coupon
            key={coupon.documentId}
            logoUrl={coupon.imageLink}
            name={coupon.name}
            description={coupon.description || 'No description available'}
            percentage={coupon.percentage}
            refetchFunction={refetch}
            id={coupon.documentId}
            webLink={coupon.webLink}
          />
        ))
      ) : (
        <div className="bg-white text-center p-5 mt-6 shadow-md">
          <p className='text-xl'>You have no coupons 😞</p>
          <p className='text-xl'>Visit the shop to buy more coupons.</p>
          <a href="https://splitdiscount.com" target="_blank" rel="noopener noreferrer">
            <IconButton
              sx={{
                margin: '8px', 
                paddingX:'10px',
                borderColor: 'var(--black1)',
                borderWidth: '1px',
                borderStyle: 'solid',
                backgroundColor: 'var(--black1)',
                color: 'var(--yellow1)',
                borderRadius: '8px',
                '&:hover': {
                    backgroundColor: 'var(--black1)', // Example hover style
                    color: 'var(--yellow1)'
                      }
              }}
            >
              <ShopIcon className='mx-2' /> Buy now
            </IconButton>
          </a>
          <br/>
          <IconButton
          size="small"
            onClick={() => window.location.reload()}
            sx={{
              margin: '8px',
              paddingX: '10px',
              borderColor: 'var(--black1)',
              borderWidth: '1px',
              borderStyle: 'solid',
              color: 'var(--black1)',
              borderRadius: '8px'
            }}
          >
            <RefreshIcon className='mx-2' /> Reload
          </IconButton>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
